export const BrandColors = {
  JLLBrandColors: {
    Red: {
      core: "#E30613",
      tint75Percent: "#FA333F",
    },
    Green: {
      core: "#556C3A",
      tint75Percent: "#789852",
      tint50Percent: "#9AB678",
      tint25Percent: "#BBCEA4",
    },
    White: {
      core: "#FFFFFF",
      tint75Percent: "#F7F7F7",
    },
    Black: {
      core: "#000000",
      tint75Percent: "#404040",
      tint50Percent: "#808080",
      tint25Percent: "#BFBFBF",
    },
    Steel: {
      core: "#626468",
      tint75Percent: "#898B8E",
      tint50Percent: "#B0B1B3",
      tint25Percent: "#D8D8D9",
    },
    Concrete: {
      core: "#B1B2B4",
      tint75Percent: "#C5C5C7",
      tint50Percent: "#D8D9D9",
      tint25Percent: "#EBECEC",
    },
    Stone: {
      core: "#DBD6C7",
      tint75Percent: "#E4E0D5",
      tint50Percent: "#EDEBE3",
      tint25Percent: "#F6F5F1",
    },
    Violet: {
      core: "#7874B5",
    },
    Success: "#7ED321",
    ComponentColors: {
      CircularProgressBar: {
        grey: "#D8D9D9",
        green: "#789852",
        red: "#C20510",
      },
      ScoreIndicators: {
        block: "#000000",
        high: "#E30613",
        medium: "#FF6900",
        low: "rgb(65, 245, 0)",
        noScore: "#cccccc",
        expired: "#666666",
      },
    },
  },
};

export default BrandColors;
